import type { Locale, RealtimeMessage } from "./types";

export function messageNotificationCopy(
  message: RealtimeMessage,
  locale: Locale,
  senderName?: string,
) {
  const fallbackTitle = locale === "zh" ? "收到新消息" : locale === "vn" ? "Tin nhắn mới" : "New message";
  const mediaBody =
    message.message_type === "image"
      ? locale === "zh"
        ? "发来了一张图片"
        : locale === "vn"
          ? "Đã gửi cho bạn một ảnh"
          : "Sent you a photo"
      : message.message_type === "video"
        ? locale === "zh" ? "发来了一段视频" : locale === "vn" ? "Đã gửi cho bạn một video" : "Sent you a video"
        : locale === "zh"
          ? "发来了一条语音"
          : locale === "vn"
            ? "Đã gửi cho bạn một tin nhắn thoại"
            : "Sent you a voice message";
  const textBody = (message.content ?? "").replace(/\s+/g, " ").trim().slice(0, 120);
  return {
    title: senderName?.trim() || fallbackTitle,
    body: message.message_type === "text" ? textBody || fallbackTitle : mediaBody,
  };
}
